import { Controller } from "@hotwired/stimulus";

// Interactive 1..5 star rating widget.
// Clicking a star sets the rating; hovering previews it; mouseleave reverts.
//
// Expected HTML structure:
//
//   <div data-controller="star-rating"
//        data-star-rating-rating-value="3">
//     <input type="hidden" data-star-rating-target="input"
//            name="review_request[rating]" value="3">
//     <button type="button"
//             data-star-rating-target="star"
//             data-star-rating-index-param="1"
//             data-action="click->star-rating#select
//                          mouseenter->star-rating#preview
//                          mouseleave->star-rating#reset">★</button>
//     ... (stars 2..5)
//   </div>
export default class extends Controller {
  static targets = ["star", "input"];
  static values = { rating: Number };

  connect() {
    this.paint(this.ratingValue);
  }

  select(event) {
    const index = this.indexFor(event.currentTarget);
    this.ratingValue = index;
    if (this.hasInputTarget) this.inputTarget.value = index;
    this.paint(index);
  }

  preview(event) {
    this.paint(this.indexFor(event.currentTarget));
  }

  reset() {
    this.paint(this.ratingValue);
  }

  indexFor(element) {
    return parseInt(element.dataset.starRatingIndexParam, 10) || 0;
  }

  paint(filledCount) {
    this.starTargets.forEach((star, idx) => {
      const filled = idx < filledCount;
      star.classList.toggle("text-yellow-400", filled);
      star.classList.toggle("text-gray-300", !filled);
    });
  }
}
